<template>
    <div>
        <el-tabs v-model="activeGraphicName" style="margin-top:-30px;" @edit="handleTabsEdit">
            <el-tab-pane :key="graphic.id" v-for="graphic in graphics" :label="graphic.title" :name="'graphic-' + graphic.id" closable>
                <div class="graphic-form">
                    <div class="graphic-archives">
                        <div :class="{actived: archive == graphic.activeArchive}" v-for="(archive, index) in graphic.archives" :key="archive.id" @click="handleActiveArchive(graphic, archive)">
                            <span>{{index + 1}}</span>
                            <div class="operations">
                                <el-button type="danger" icon="el-icon-close" circle @click="handleRemoveArchive(graphic, archive)"></el-button>
                            </div>
                        </div>
                        <span class="text-center">
                            <el-button type="text" icon="el-icon-edit-outline" @click="handleUpdateGraphic(graphic)"></el-button>
                            <el-button type="text" icon="el-icon-plus" @click="handleAddArchive(graphic)"></el-button>
                        </span>
                    </div>
                    <div class="graphic-content">
                        <Archive :graphic="graphic" v-model="graphic.activeArchive" v-if="graphic.activeArchive"></Archive>
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane :label="editGraphicCaption" name="edit" :closable="false">
                <el-form class="grammar-graphic-form" label-width="80px" style="max-width:500px;">
                    <el-form-item label="类别">
                        <el-select v-model="editGraphicType" filterable :clearable="true">
                            <el-option v-for="item in graphicTypes" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="名称">
                        <el-input v-model="editGraphicName"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="handleSubmitGraphicEdit">确 定</el-button>
                        <el-button v-if="editGraphicId" @click="handleResetGraphicEdit">关 闭</el-button>
                    </el-form-item>
                </el-form>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
import Archive from '../graphic/Archive.vue'
export default {
    name: 'GrammarGraphic',
    props: {
        gid: Number
    },
    components: { Archive },
    data() {
        return {
            sign: null,
            graphics: [],
            activeGraphicName: null,
            editGraphicCaption: '添加',
            editGraphicId: 0,
            editGraphicName: '',
            updateing: 0,
            graphicTypes: [
                { id: 'intro', name: '引入页' },
                { id: 'example', name: '例子页' },
                { id: 'explain', name: '解释页' },
            ],
            editGraphicType: '',
        }
    },
    watch: {
        gid() {
            this.fetchGraphics()
        },
        activeGraphicName() {
            this.loadGraphicArchives(this.activeGraphic)
        },
        editGraphicType(newVal, oldVal) {
            let newType = this.graphicTypes.find(g => g.id == newVal)
            let oldType = this.graphicTypes.find(g => g.id == oldVal)
            if (newType && !this.editGraphicId && (!this.editGraphicName || !oldType || this.editGraphicName == oldType.name)) {
                this.editGraphicName = newType.name
            }
        }
    },
    created() {
        this.fetchGraphics()
    },
    computed: {
        activeGraphic() {
            return this.graphics.find(g => this.activeGraphicName == 'graphic-' + g.id)
        },
    },
    methods: {
        fetchGraphics() {
            return this.$http.get(this.$urls.graphic_list, {
                params: {
                    page: 1,
                    'per-page': 999,
                    'filter[ref_type]': 'grammar',
                    'filter[ref_id]': this.gid,
                    'filter[status]': 1,
                    'filter[deleted]': 0,
                }
            }).then(res => {
                this.graphics = res.data
                this.graphics.forEach(this.initGraphic)
                if (this.graphics[0]) {
                    this.activeGraphicName = 'graphic-' + this.graphics[0].id
                } else {
                    this.activeGraphicName = 'edit'
                }
            })
        },
        initGraphic(graphic) {
            if (!graphic.archives) {
                this.$set(graphic, 'archives', [])
            }
            if (graphic.activeArchive === null && graphic.archives[0]) {
                this.$set(graphic, 'activeArchive', graphic.archives[0])
            } else {
                this.$set(graphic, 'activeArchive', null)
            }
        },
        loadGraphicArchives(graphic) {
            if (!graphic || graphic.archives.length > 0) return
            this.$http.get(this.$urls.graphic_archive_data, {
                params: {
                    'graphic_id': graphic.id,
                }
            }).then(res => {
                graphic.archives = res.data
                graphic.activeArchive = res.data && res.data.length > 0 ? res.data[0] : null
                if (!graphic.archives || graphic.archives.length == 0) {
                    this.createArchive({
                        graphic_id: graphic.id,
                        index_number: 1,
                    }).then(arch => {
                        this.addArchive(graphic, arch.data)
                    })
                }
            })
        },
        handleSubmitGraphicEdit() {
            if (this.editGraphicId) {
                let gid = this.editGraphicId
                this.updateGraphic().then(res => {
                    let graphic = this.graphics.find(g => g.id == gid)
                    if (graphic) {
                        Object.assign(graphic, res.data)
                    }
                })
            } else {
                this.createGraphic().then(res => {
                    let graphic = res.data
                    this.graphics.push(graphic)
                    this.activeGraphicName = 'graphic-' + graphic.id
                    this.initGraphic(graphic)
                })
            }
            
        },
        createGraphic(params) {
            if (this.updateing > 0) {
                return Promise.reject();
            }
            this.updateing++;
            return this.$http.post(this.$urls.graphic_create, Object.assign({
                ref_type: 'grammar',
                ref_id: this.gid,
                title: this.editGraphicName,
                category: this.editGraphicType,
            }, params || {})).then(res => {
                this.updateing--;
                this.handleResetGraphicEdit()
                return res
            }).catch(err => {
                this.updateing--;
            })
        },
        updateGraphic(params) {
            if (this.updateing > 0 || !this.editGraphicId) {
                return Promise.reject();
            }
            this.updateing++;
            return this.$http.put(this.$urls.graphic_update, Object.assign({
                ref_type: 'grammar',
                ref_id: this.gid,
                title: this.editGraphicName,
                category: this.editGraphicType,
            }, params || {}), {
                params: { id: this.editGraphicId }
            }).then(res => {
                this.updateing--;
                this.handleResetGraphicEdit()
                return res
            }).catch(err => {
                this.updateing--;
            })
        },
        handleUpdateGraphic(graphic) {
            this.editGraphicId = graphic.id
            this.activeGraphicName = 'edit'
            this.editGraphicName = graphic.title
            this.editGraphicType = graphic.category
            this.editGraphicCaption = '编辑:' + graphic.title
        },
        handleResetGraphicEdit() {
            if (this.editGraphicId)  {
                this.activeGraphicName = 'graphic-' + this.editGraphicId
            }
            this.editGraphicId = 0
            this.editGraphicName = ''
            this.editGraphicType = ''
            this.editGraphicCaption = '添加'

        },
        createArchive(params) {
            if (this.updateing > 0 || !this.activeGraphic) {
                return Promise.reject();
            }
            this.updateing++;
            return this.$http.post(this.$urls.graphic_archive_create, Object.assign({
                graphic_id: this.activeGraphic.id,
                title: '',
            }, params || {})).then(res => {
                this.updateing--;
                return res
            }).catch(err => {
                this.updateing--;
            })
        },
        handleAddArchive(graphic) {
            this.$confirm(`添加文档${this.activeGraphic.archives.length + 1}到${this.activeGraphic.title}?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(res => {
                this.createArchive({
                    graphic_id: graphic.id,
                    index_number: graphic.archives.length + 1,
                }).then(arch => {
                    this.addArchive(graphic, arch.data)
                })
            })
        },
        handleRemoveArchive(graphic, archive) {
            let index = graphic.archives.findIndex(arch => arch.id == archive.id) + 1
            this.$confirm(`确定要删除文档${index}吗?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(res => {
                return this.$http.post(this.$urls.graphic_archive_delete, {
                    id: archive.id,
                }, {
                    params: {id: archive.id,}
                }).then(res => {
                    let key = graphic.archives.findIndex(arch => arch.id == archive.id)
                    graphic.archives.splice(key, 1)
                    this.resetActiveArchive(graphic, key - 1)
                    return res
                })
            })
        },
        resetActiveArchive(graphic, index) {
            if (!graphic || !graphic.archives) {
                return
            }
            if (index < 0) {
                index = 0
            } else if(index >= graphic.archives.length) {
                index = graphic.archives.length - 1
            }
            if (graphic.archives[index]) {
                this.$set(graphic, 'activeArchive', graphic.archives[index])
            }
        },
        addArchive(graphic, archive) {
            this.initArchive(archive)
            graphic.archives.push(archive)
            graphic.activeArchive = archive
        },
        initArchive(archive) {
            if (!archive.details) {
                archive.details = []
            }
            return archive
        },
        handleActiveArchive(graphic, archive) {
            graphic.activeArchive = archive
        },
        handleTabsEdit(targetName, action) {
            if (action === 'remove') {
                this.$confirm(`确定要删除吗?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(res => {
                    let gid = targetName.split('-')[1]
                    this.$http.put(this.$urls.graphic_update, {
                        deleted: 1
                    }, {
                        params: { id: gid }
                    }).then(res => {
                        let index = this.graphics.findIndex(g => g.id == gid)
                        this.graphics.splice(index, 1)
                        if (this.activeGraphicName == targetName) {
                            if (this.graphics.length > 0) {
                                this.activeGraphicName = 'graphic-' + this.graphics[0].id
                            } else {
                                this.activeGraphicName = 'edit'
                            }
                        }
                    })
                })
            }
        }
    }
}
</script>
<style lang="scss">
.graphic-form {
    display: flex;

    >.graphic-archives {
        width: 150px;
        margin-right: 15px;
        border-right: 1px solid #eee;
        padding-right: 15px;
        display: flex;
        flex-direction: column;

        .operations{
            display: none;
            position:absolute;
            top: 0;
            right: 0;
            line-height: 1;
            padding: 3px;
            text-align: right;
            >.el-button{
                padding: 3px;
                font-size: 12px;
            }
        }

        >div {
            border: 1px solid #eee;
            height: 80px;
            text-align: center;
            line-height: 80px;
            position: relative;
            cursor: pointer;

            +div {
                margin-top: 15px;
            }

            &:hover,
            &.actived {
                background-color: #f0f9eb;
                border-color: #67C23A;
            }

            &:hover {
                .operations{
                    display: block;
                }
            }
        }
        
    }

    >.graphic-content {
        flex: 1;
    }
}
</style>